import React, { useState } from 'react';

import Popover from '@material-ui/core/Popover';

import Button from '../../../../../../components/Button';
import Input from '../../../../../../components/Input';

interface IProps {
  onSave: (name: string) => Promise<any>;
}

export const AddPageWidget = (props: IProps) => {
  const { onSave } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [name, setName] = useState('');

  const open = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const onChange = (event: any) => {
    setName(event.target.value);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const save = async () => {
    await onSave(name);
    setAnchorEl(null);
    setName('');
  };

  const isOpen = Boolean(anchorEl);

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        className="button add-page-button"
        aria-owns={isOpen ? 'add-page-popover' : undefined}
        aria-haspopup="true"
        onClick={open}
      >
        Add new Policy Section
      </Button>

      <Popover
        id="add-page-popover"
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        transformOrigin={{
          horizontal: 'center',
          vertical: 'top'
        }}
        classes={{
          paper: 'add-page-popover-paper'
        }}
      >
        <div className="add-page-form">
          <Input
            type="text"
            placeholder="Page Name"
            label="Page Name"
            id="page-name"
            onChange={onChange}
          />

          <Button
            color="primary"
            variant="contained"
            className="button add-page-button"
            aria-owns={isOpen ? 'render-props-popover' : undefined}
            aria-haspopup="true"
            onClick={save}
          >
            Add New Page
          </Button>
        </div>
      </Popover>
    </>
  );
};
